<template>
  <CContainer fluid>
    <!-- <h3>Documentos Anexos</h3> -->
    <CDataTable
      hover
      responsive
      :fields="fields"
      :items="records">
      <template #documento="{item}">
        <td>
          <div>
            <strong>{{ item.tipo_Anexo }}</strong>
          </div>
          <div>
            <small>
              {{ item.nombre_Documento }}
            </small>
          </div>
          <div>
            <small>
              {{ moment(item.fecha_Creacion).format("DD/MM/YYYY - hh:mm:ss") }}
            </small>
          </div>
        </td>
      </template>
      <template #acciones="{item}">
        <td>
          <div class="d-flex justify-content-end">
            <a href="#" 
              @click="(event) => {
                tryDelete(event, item.id_DocumentoAnexo)
              }">
              <i class="bi bi-trash text-danger h5"></i>
            </a>
            <a href="#" 
              class="ml-2" 
              @click="(event) => {
                descargaDocumento(item.id_DocumentoAnexo)
              }">
              <i class="bi bi-cloud-download text-info h5"></i>
            </a>
          </div>
        </td>
      </template>
    </CDataTable>

    <CElementCover v-show="loading" />
  </CContainer>
</template>
<script>
  import moment from "moment"
  import CONSTANTS from "@/constants";
  import { formatter } from "@/general";
  import { dataGridDocumentosAnexos } from "@/apiDataGrids";
  import { borraDocumentoAnexo } from "@/api";
  // import { downloadFileObject } from "../../api"

  const fields = [
    {
      key: "documento",
      label: "Documento",
      _style: "text-align:center"
    },
    {
      key: "acciones",
      label: "",
      _style: "text-align:center"
    }
  ]

  export default {
    name: "AttachedDocuments",
    setup() {
      console.log("Entro al setup...")
    },
    data() {
      return {
        formatter,
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        fields,
        records: [],
        idSelectedItem: ""
      }
    },
    props: {
      typeQuery: String,
      id: String
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true

        try {
          // this.searchWord = search

          const { count, results } = await dataGridDocumentosAnexos(this, this.typeQuery, this.id, page, search)

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

          this.records = results
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos.",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      tryDelete(e, idAttachment) {
        e.preventDefault();
        e.stopPropagation();

        this.idSelectedItem = idAttachment;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar el pedido?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
            this.deleteAttachment();
        }).catch(() => {
            this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      async deleteAttachment() {
        this.loading = true

        try {
          await borraDocumentoAnexo(this, this.idSelectedItem);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });

          this.getData();
        } catch (error) {
          const { errorCode, errorMessage } = error.data;

          this.$store.commit("setAlert", {
            color: "danger",
            message: `${CONSTANTS.messages.notDoneDelete} Error: (${errorCode}) - ${errorMessage}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
        this.getData()
    }
  }
</script>
